import React from 'react';
import { supabase } from '../lib/supabase';

interface FooterProps {
  navigate: (to: string) => void;
}

function Footer({ navigate }: FooterProps) {
  return (
    <footer className="bg-gradient-to-r from-indigo-600 to-purple-600 py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <p className="text-sm text-white">
              &copy; {new Date().getFullYear()} PM Pro AI. All rights reserved.
            </p>
          </div>
          <div className="flex space-x-6">
            <button
              onClick={() => navigate('/privacy-policy')}
              className="text-sm text-white hover:text-gray-200"
            >
              Privacy Policy
            </button>
            <button
              onClick={() => navigate('/terms-and-conditions')}
              className="text-sm text-white hover:text-gray-200"
            >
              Terms & Conditions
            </button>
            <button
              onClick={() => navigate('/cookies-policy')}
              className="text-sm text-white hover:text-gray-200"
            >
              Cookies Policy
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;